"use client";

import NextLink from "next/link";

import { Button } from "@/components/ui/button";
import { track } from "@/lib/analytics/data-layer";

/**
 * "Começar agora" of "Como montar a sua lista": the same button it always was, now telling the
 * analytics that the host's way in was pressed from this section (`select_content`, as the hero's
 * and the duo's CTAs do). A client component of its own only because the section around it is not.
 */
export function StepsCta() {
  return (
    <Button asChild size="lg" className="w-fit gap-3 px-[30px] text-[12px] font-bold text-[var(--tb-white)] duration-[400ms]">
      <NextLink
        href="/onboarding"
        onClick={() =>
          track({
            event: "select_content",
            content_type: "cta",
            item_id: "host_create_list",
            location: "steps",
            journey: "host",
            link_url: "/onboarding",
          })
        }
      >
        Começar agora
      </NextLink>
    </Button>
  );
}
